<mat-form-field2 class="mat-block" [showLabel]="!inline">
  <app-select
    [required]="ctrl | required"
    [items]="timezoneList"
    [searchable]="true"
    [formControl]="ctrl"
    [placeholder]="label"
  >
  </app-select>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    <ng-container i18n>Time zone is required</ng-container>
  </mat-error>
</mat-form-field2>
